import React, { useState } from 'react';
import { 
  Sparkles, 
  Zap, 
  Wand2,
  Package,
  Clock,
  Target,
  Gem,
  BarChart3,
  Lightbulb
} from 'lucide-react';
import './HelloSentences.css';

const sentences = [
  // Core features - Text to Slides
  { text: "Describe it, we'll design it", icon: Sparkles },
  { text: "Text prompts to presentations", icon: BarChart3 },
  { text: "What's your presentation about?", icon: Lightbulb },
  { text: "Ideas → AI → Beautiful slides", icon: Wand2 },

  { text: "Just type a topic and hit send", icon: Zap },
  { text: "Paste content, we'll structure it", icon: Package },
  { text: "Describe each slide separately", icon: BarChart3 },
  
  // Value proposition
  { text: "Content to export, automated", icon: Zap },
  { text: "Create once, export everywhere", icon: Package },
  { text: "Skip design, start presenting", icon: Target },
  { text: "Minutes, not hours", icon: Clock },
  
  // User-focused
  { text: "Ready to automate?", icon: Zap },
  { text: "What will you create?", icon: Sparkles },
  { text: "Better than templates", icon: Gem }
];

export default function HelloSentences() {
  const [current] = useState(() => {
    return sentences[Math.floor(Math.random() * sentences.length)];
  });

  const IconComponent = current.icon;

  return (
    <div className="hello-sentences">
      <h1 className="hello-text">
        {current.text}
        <IconComponent className="hello-icon" size={28} strokeWidth={2} />
      </h1>
    </div>
  );
}